import { useSelector } from 'react-redux';
import { getBackSeatUrl, getCenterConsoleUrl } from '../store/car-slice';

export function useInteriorExist() {
  const centerConsoleUrl = useSelector(getCenterConsoleUrl);
  const backSeatUrl = useSelector(getBackSeatUrl);

  const isInteriorExist = centerConsoleUrl || backSeatUrl;

  return {
    isInteriorExist,
    isCenterConsoleExist: Boolean(centerConsoleUrl),
    isBackSeatExist: Boolean(backSeatUrl),
  };
}
